// Mock data for South Sea Design Studio — HBA-style interior design & fit-out site
// NOTE: All data below is mocked for the frontend-only preview.

export const brand = {
  name: "South Sea",
  suffix: "Design Studio",
  tagline: "Spaces for a better tomorrow",
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_57f404e7-f51e-4c95-8cce-2f45b2a487f5/artifacts/1olalxbr_Logo.jpeg",
  pillars: ["Design", "Consult", "Execute"],
};

export const contactInfo = {
  phone: "+91 98863 34239",
  email: "southsea.interiors@outlook.com",
  website: "www.southseainterior.com",
  location: "Bengaluru, Karnataka, India",
  gstin: "29EFXPS5529J1Z9",
};

export const heroSlides = [
  {
    image: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4OTczMzgxOXww&ixlib=rb-4.1.0&q=85",
    place: "Coastal Residence, Bengaluru",
  },
  {
    image: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk3MzM4MTl8MA&ixlib=rb-4.1.0&q=85",
    place: "Private Villa, Whitefield",
  },
  {
    image: "https://images.unsplash.com/photo-1660557989695-14fac79c086d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGxvYmJ5fGVufDB8fHx8MTc4OTczMzg1MXww&ixlib=rb-4.1.0&q=85",
    place: "Hospitality Lobby, MG Road",
  },
];

export const overview = {
  eyebrow: "Overview",
  headline: "Designing spaces that move people.",
  body: "At South Sea Design Studio, we create functional, aesthetic and enduring spaces through thoughtful design and meticulous execution. From concept to completion, we are one partner shaping environments that elevate the way people live, work and experience.",
  script: "Spaces That Inspire",
};

export const featuredProjects = [
  {
    id: "residential",
    title: "Residential",
    subtitle: "Homes that reflect you",
    location: "Bengaluru",
    year: "2024",
    studio: "South Sea | Interiors",
    image: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4OTczMzgxOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "office",
    title: "Office Spaces",
    subtitle: "Workplaces that perform",
    location: "Bengaluru",
    year: "2024",
    studio: "South Sea | Fit-out",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk3MzM4NTF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "retail",
    title: "Retail Spaces",
    subtitle: "Spaces that attract",
    location: "Bengaluru",
    year: "2023",
    studio: "South Sea | Interiors",
    image: "https://images.unsplash.com/photo-1567958451986-2de427a4a0be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZXRhaWwlMjBzdG9yZXxlbnwwfHx8fDE3ODk3MzM4NTF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "commercial",
    title: "Commercial",
    subtitle: "Built for business",
    location: "Bengaluru",
    year: "2023",
    studio: "South Sea | Construction",
    image: "https://images.unsplash.com/photo-1660557989688-1564893ccf8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxob3RlbCUyMGxvYmJ5fGVufDB8fHx8MTc4OTczMzg1MXww&ixlib=rb-4.1.0&q=85",
  },
];

export const services = [
  {
    id: "consultation",
    title: "Design Consultation",
    description: "Concept development, space planning, 3D visualisation and design advisory tailored to your vision.",
  },
  {
    id: "architectural",
    title: "Architectural Design Services",
    description: "Architectural planning, approvals support and design solutions for new and existing buildings.",
  },
  {
    id: "interior",
    title: "Interior Design & Execution",
    description: "End-to-end interior fit-out with quality craftsmanship and timely, dependable delivery.",
  },
  {
    id: "construction",
    title: "Construction Services",
    description: "Civil construction, renovation and project management with reliable, trusted partners.",
  },
];

export const processSteps = [
  { step: "01", title: "Discover", description: "Understand your needs, aspirations and the story of your space." },
  { step: "02", title: "Design", description: "Create tailored, considered solutions that balance form and function." },
  { step: "03", title: "Execute", description: "Deliver with precision, craftsmanship and meticulous attention to detail." },
  { step: "04", title: "Support", description: "Ensure lasting value long after handover with dependable aftercare." },
];

export const values = [
  { title: "Quality", description: "Crafted with care" },
  { title: "Client Centric", description: "Your vision, our priority" },
  { title: "Sustainable", description: "Thoughtful & responsible" },
  { title: "Trusted", description: "Reliable delivery" },
];

export const aboutBlock = {
  eyebrow: "About",
  title: "South Sea Design Studio",
  body: "South Sea Design Studio is a registered company specialising in design consultation and execution of interior fit-out and construction projects. We combine creativity, functionality and technical expertise to deliver spaces that elevate the way people live, work and experience.",
  keywords: ["People", "Spaces", "Ideas", "Impact"],
  image: "https://images.unsplash.com/photo-1758957701419-2c6e266f7988?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg5NzMzODE5fDA&ixlib=rb-4.1.0&q=85",
  quote: "Good spaces, brighter tomorrows.",
};

export const galleryProjects = [
  { id: 1, title: "Terrace Residence", category: "Residential", location: "Bengaluru", year: "2024", image: "https://images.unsplash.com/photo-1581783458534-001a466b5487?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk3MzM4MTl8MA&ixlib=rb-4.1.0&q=85" },
  { id: 2, title: "Marble Lounge", category: "Residential", location: "Whitefield", year: "2024", image: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk3MzM4MTl8MA&ixlib=rb-4.1.0&q=85" },
  { id: 3, title: "Studio HQ", category: "Office", location: "Koramangala", year: "2024", image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk3MzM4NTF8MA&ixlib=rb-4.1.0&q=85" },
  { id: 4, title: "The Boutique", category: "Retail", location: "Indiranagar", year: "2023", image: "https://images.pexels.com/photos/37793325/pexels-photo-37793325.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 5, title: "Grand Lobby", category: "Commercial", location: "MG Road", year: "2023", image: "https://images.unsplash.com/photo-1660557989695-14fac79c086d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGxvYmJ5fGVufDB8fHx8MTc4OTczMzg1MXww&ixlib=rb-4.1.0&q=85" },
  { id: 6, title: "Skyline Suite", category: "Residential", location: "Bengaluru", year: "2023", image: "https://images.unsplash.com/photo-1581784878214-8d5596b98a01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk3MzM4MTl8MA&ixlib=rb-4.1.0&q=85" },
  { id: 7, title: "Workspace Loft", category: "Office", location: "HSR Layout", year: "2024", image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk3MzM4NTF8MA&ixlib=rb-4.1.0&q=85" },
  { id: 8, title: "Flagship Store", category: "Retail", location: "Bengaluru", year: "2023", image: "https://images.unsplash.com/photo-1567958451986-2de427a4a0be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZXRhaWwlMjBzdG9yZXxlbnwwfHx8fDE3ODk3MzM4NTF8MA&ixlib=rb-4.1.0&q=85" },
  { id: 9, title: "Living Pavilion", category: "Residential", location: "Bengaluru", year: "2024", image: "https://images.pexels.com/photos/33599113/pexels-photo-33599113.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 10, title: "Executive Floor", category: "Commercial", location: "Bengaluru", year: "2023", image: "https://images.unsplash.com/photo-1660557989688-1564893ccf8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxob3RlbCUyMGxvYmJ5fGVufDB8fHx8MTc4OTczMzg1MXww&ixlib=rb-4.1.0&q=85" },
  { id: 11, title: "Garden Home", category: "Residential", location: "Sarjapur", year: "2024", image: "https://images.pexels.com/photos/8092431/pexels-photo-8092431.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 12, title: "Reading Lounge", category: "Residential", location: "Bengaluru", year: "2023", image: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4OTczMzgxOXww&ixlib=rb-4.1.0&q=85" },
];

export const galleryCategories = ["All", "Residential", "Office", "Retail", "Commercial"];

export const navLinks = [
  { label: "Home", type: "section", target: "top", to: "/" },
  { label: "About", type: "section", target: "about", to: "/" },
  { label: "Services", type: "section", target: "services", to: "/" },
  { label: "Spaces", type: "section", target: "spaces", to: "/" },
  { label: "Process", type: "section", target: "process", to: "/" },
  { label: "Projects", type: "route", to: "/projects" },
  { label: "Contact", type: "route", to: "/contact" },
];
